function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.525 5.9h-2.52V4.5c0-.722.06-1.177 1.117-1.177h1.336V1.097A18.82 18.82 0 009.5 1C7.56 1 6.145 2.16 6.145 4.29V5.9H4v2.8h2.145V15h2.86V8.698h2.192l.328-2.798z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgFacebookinline;